<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="文章标题" prop="articleTitle">
                <a-input v-model="queryParam.articleTitle" placeholder="请输入文章标题" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否启用" prop="enabled">
                <a-select v-model="queryParam.enabled" :placeholder="'请选择'">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="阅读数量" prop="readNum">
                  <a-input v-model="queryParam.readNum" placeholder="请输入阅读数量" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="排序" prop="sortNum">
                  <a-input v-model="queryParam.sortNum" placeholder="请输入排序" allow-clear/>
                </a-form-item>
              </a-col>

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['article:article:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['article:article:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['article:article:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['article:article:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1140 }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="imgs" slot-scope="text, record">
          <template v-if="getArticleCover(record)">
            <a-tooltip title="点击查看大图">
              <span
                class="article-cover-cell"
                role="button"
                tabindex="0"
                @click="openCoverPreview(getArticleCover(record))"
                @keyup.enter="openCoverPreview(getArticleCover(record))"
              >
                <img
                  :src="getArticleCover(record)"
                  alt="封面"
                  class="article-cover-thumb"
                  loading="lazy"
                  @error="handleCoverImgError"
                />
              </span>
            </a-tooltip>
          </template>
          <span v-else class="article-cover-placeholder">
            <a-icon type="picture" />
            <span class="article-cover-placeholder__text">暂无</span>
          </span>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['article:article:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['article:article:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['article:article:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
        <span slot="enabled" slot-scope="text, record">
          <a-tag v-if="record.enabled === 1" color="green">是</a-tag>
          <a-tag v-else-if="record.enabled === 0" color="default">否</a-tag>
          <span v-else>-</span>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <a-modal
        :visible="coverPreviewVisible"
        :footer="null"
        title="封面预览"
        :width="720"
        centered
        destroy-on-close
        @cancel="closeCoverPreview"
      >
        <div class="article-cover-preview-wrap">
          <img :src="coverPreviewUrl" alt="封面大图" class="article-cover-preview-img" />
        </div>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageArticle,listArticle, delArticle } from '@/api/article/article'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Article',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      coverPreviewVisible: false,
      coverPreviewUrl: '',
      // 查询参数
      queryParam: {
        articleTitle: null,
        articleContent: null,
        readNum: null,
        sortNum: null,
        enabled: '',
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '文章标题',
          dataIndex: 'articleTitle',
          ellipsis: true,
          align: 'center',
          width: 180
        },
        {
          title: '封面',
          dataIndex: 'imgs',
          align: 'center',
          width: 108,
          scopedSlots: { customRender: 'imgs' }
        },
        {
          title: '文章内容',
          dataIndex: 'articleContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '阅读数量',
          dataIndex: 'readNum',
          ellipsis: true,
          align: 'center',
          width: 100
        },
        {
          title: '排序',
          dataIndex: 'sortNum',
          ellipsis: true,
          align: 'center',
          width: 80
        },
        {
          title: '是否启用',
          dataIndex: 'enabled',
          ellipsis: true,
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'enabled' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 140,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询文章列表 */
    getList () {
      this.loading = true
     pageArticle(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        articleTitle: undefined,
        articleContent: undefined,
        readNum: undefined,
        sortNum: undefined,
        enabled: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delArticle(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** imgs 逗号分隔，取首张 URL */
    getArticleCover (record) {
      const imgs = record && record.imgs
      if (!imgs) {
        return ''
      }
      const first = String(imgs).split(',')[0].trim()
      return first || ''
    },

    openCoverPreview (url) {
      if (!url) {
        return
      }
      this.coverPreviewUrl = url
      this.coverPreviewVisible = true
    },

    closeCoverPreview () {
      this.coverPreviewVisible = false
      this.coverPreviewUrl = ''
    },

    /** 缩略图加载失败时隐藏，避免裂图 */
    handleCoverImgError (e) {
      const el = e && e.target
      if (el && el.style) {
        el.style.visibility = 'hidden'
      }
      if (el && el.parentElement) {
        el.parentElement.classList.add('article-cover-cell--error')
      }
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('article/article/export', {
            ...that.queryParam
          }, `文章_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.article-cover-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  cursor: pointer;
  border-radius: 6px;
  outline: none;
  vertical-align: middle;

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.35);
  }
}

.article-cover-thumb {
  display: block;
  width: 72px;
  height: 54px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.article-cover-cell:hover .article-cover-thumb {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.article-cover-cell--error {
  min-width: 72px;
  min-height: 54px;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: not-allowed;
  pointer-events: none;

  &::after {
    content: '加载失败';
    font-size: 12px;
    color: rgba(0, 0, 0, 0.35);
    line-height: 1.2;
    padding: 0 4px;
    text-align: center;
  }
}

.article-cover-placeholder {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 54px;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.25);
  background: #fafafa;
  border: 1px dashed #e8e8e8;
  border-radius: 6px;
  font-size: 18px;
  vertical-align: middle;

  .article-cover-placeholder__text {
    margin-top: 2px;
    font-size: 11px;
    line-height: 1;
    color: rgba(0, 0, 0, 0.35);
  }
}

.article-cover-preview-wrap {
  text-align: center;
  max-height: 70vh;
  overflow: auto;
}

.article-cover-preview-img {
  max-width: 100%;
  vertical-align: middle;
  border-radius: 4px;
}
</style>
